import * as ReferenceActions from './reference.actions';
import * as OU from '../util/object-utils';
import { Snapshot } from '../model/snapshots/snapshot.model';

export enum ReferenceContextPropertyName {
  Location = "locationID",
  LocationType = "locationTypeID",
  Region = "regionID",
  Entity = "entityID"
}

export enum ReferenceContextObjectName {
  Location = "Location",
  LocationType = "LocationType",
  Region = "Region",
  Entity = "Entity"
}

export interface ReferenceContext {
  locationID: string[];
  entityID: string[];
  regionID: string[];
  locationTypeID: string[];
  ActiveSnapshot: Snapshot;
}

export const initialState: ReferenceContext = {
  locationTypeID: [],
  entityID: [],
  regionID: [],
  locationID: [],
  ActiveSnapshot: null
};

export function referenceReducer(state = initialState, action: ReferenceActions.ReferenceActions): ReferenceContext {
  switch (action.type) {

    case ReferenceActions.LOCATION_TYPES_CHANGED:
      return {
        ...state,
        locationTypeID: action.payload
      };

    case ReferenceActions.ENTITIES_CHANGED:
      return {
        ...state,
        entityID: action.payload
      };

    case ReferenceActions.REGIONS_CHANGED:
      return {
        ...state,
        regionID: action.payload,
      };

    case ReferenceActions.LOCATION_IDS_CHANGED:
      return {
        ...state,
        locationID: action.payload
      };
    case ReferenceActions.UPDATE_REFERENCE:
      return {
        ...state,
        ...action.payload
      };
    case ReferenceActions.ACTIVE_SNAPSHOT_CHANGED:
      return {
        ...state,
        ActiveSnapshot: action.payload
      };
    case ReferenceActions.REFERENCE_DEMO_RESET:
      return OU.copyObjectWithoutNullsOrGraphQLMetaKeys(action.context) as ReferenceContext;

    default:
      return state;
  }
}
